import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Nominations criteria section for FAQ Page
 */
const NominationsCriteriaSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="nominations-criteria-section-component"
    >
      <AccordionV2
        testId="nominations-criteria"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="What are the nomination criteria for each award?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-4 px-6 py-4">
          <p>
            Nomination is open for all categories except special recognition
            award.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default NominationsCriteriaSection;
